import { render, staticRenderFns } from "./lawMakingReview.vue?vue&type=template&id=378f3a33"
import script from "./lawMakingReview.vue?vue&type=script&lang=js"
export * from "./lawMakingReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('378f3a33')) {
      api.createRecord('378f3a33', component.options)
    } else {
      api.reload('378f3a33', component.options)
    }
    module.hot.accept("./lawMakingReview.vue?vue&type=template&id=378f3a33", function () {
      api.rerender('378f3a33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/review/lawMakingReview.vue"
export default component.exports